import {
  COLD_AND_COUGH,
  EAR_PAIN_OR_INFECTION,
  FEVER,
  RASH,
  SORE_THROAT,
  URINARY_TRACT_INFECTION,
} from '../../Home/Tiles/symptoms';

export const TIME_SELECT_OPTIONS = [
  { label: 'ASAP', hourOffset: 0, dayOffset: 0, extraLabel: '' },
  { label: 'This morning', hourOffset: 7, dayOffset: 0, extraLabel: '' },
  { label: 'This afternoon', hourOffset: 13, dayOffset: 0, extraLabel: '' },
  {
    label: 'This evening',
    hourOffset: 17,
    dayOffset: 0,
    extraLabel: ' (after 5:00pm)',
  },
  { label: 'Tomorrow morning', hourOffset: 7, dayOffset: 1, extraLabel: '' },
  { label: 'Tomorrow afternoon', hourOffset: 13, dayOffset: 1, extraLabel: '' },
  {
    label: 'Tomorrow evening',
    hourOffset: 17,
    dayOffset: 1,
    extraLabel: ' (after 5:00pm)',
  },
];

export const generateDefaultSuggestions = callback => [
  {
    primary: 'Urgent Care',
    outOfMarketCompatible: true,
    inMarketCompatible: true,
    key: 'UrgentCare-default',
    onClick: () =>
      callback({
        highlight: 'Urgent Care',
        provider_type: 'urgent_care',
        type: 'provider-type',
      }),
    fullDoc: { provider_type: 'urgent_care', type: 'provider-type' },
  },
  {
    primary: 'Dentists',
    key: 'Dentists-default',
    inMarketCompatible: true,
    onClick: () =>
      callback({
        highlight: 'Dentist',
        provider_type: 'dentist',
        type: 'provider-type',
      }),
    fullDoc: { provider_type: 'dentist', type: 'provider-type' },
  },
  {
    primary: 'Chiropractor',
    key: 'Chiropractor-default',
    inMarketCompatible: true,
    onClick: () =>
      callback({
        highlight: 'Chiropractor',
        provider_type: 'chiropractor',
        type: 'provider-type',
      }),
    fullDoc: { provider_type: 'chiropractor', type: 'provider-type' },
  },
  {
    primary: 'OB-GYN',
    key: 'OB-GYN-default',
    inMarketCompatible: true,
    onClick: () =>
      callback({
        highlight: 'OB-GYN',
        provider_type: 'ob-gyn',
        type: 'provider-type',
      }),
    fullDoc: { provider_type: 'ob-gyn', type: 'provider-type' },
  },
  {
    primary: 'Allergists',
    key: 'Allergists-default',
    onClick: () =>
      callback({
        highlight: 'Allergist',
        provider_type: 'allergist',
        type: 'provider-type',
        inMarketCompatible: true,
      }),
    fullDoc: { provider_type: 'allergist', type: 'provider-type' },
  },
  {
    primary: 'Dermatologists',
    key: 'Dermatologists-default',
    inMarketCompatible: true,
    onClick: () =>
      callback({
        highlight: 'Dermatologist',
        provider_type: 'dermatologist',
        type: 'provider-type',
      }),
    fullDoc: { provider_type: 'dermatologist', type: 'provider-type' },
  },
  {
    primary: 'Optometrists',
    key: 'Optometrists-default',
    inMarketCompatible: true,
    onClick: () =>
      callback({
        highlight: 'Optometrist',
        provider_type: 'optometrist',
        type: 'provider-type',
      }),
    fullDoc: { provider_type: 'optometrist', type: 'provider-type' },
  },
  {
    primary: 'Imaging',
    key: 'Imagings-default',
    type: 'provider-type',
    inMarketCompatible: true,
    onClick: () =>
      callback({
        highlight: 'Imaging',
        provider_type: 'imaging',
        type: 'provider-type',
      }),
    fullDoc: { provider_type: 'imaging', type: 'provider-type' },
  },
  ...[FEVER, COLD_AND_COUGH, URINARY_TRACT_INFECTION, EAR_PAIN_OR_INFECTION, RASH, SORE_THROAT].map(
    symptom => ({
      primary: symptom,
      secondary: 'Urgent Care',
      outOfMarketCompatible: true,
      inMarketCompatible: false,
      key: symptom,
      onClick: () =>
        callback({
          highlight: symptom,
          provider_type: 'urgent_care',
          type: 'symptom',
          name: symptom,
        }),
      fullDoc: { provider_type: 'urgent_care', type: 'symptom' },
    })
  ),
];
